import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import MenuIcon from '@mui/icons-material/Menu';
import VideoLibraryIcon from '@mui/icons-material/VideoLibrary';
import UploadIcon from '@mui/icons-material/Upload';
import DownloadIcon from '@mui/icons-material/Download';
import TranscribeIcon from '@mui/icons-material/Transcribe';
import CreateIcon from '@mui/icons-material/Create';
import BarChartIcon from '@mui/icons-material/BarChart';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import PricingIcon from '@mui/icons-material/AttachMoney';
import ContactIcon from '@mui/icons-material/ContactMail';
import InfoIcon from '@mui/icons-material/Info';
import LoginIcon from '@mui/icons-material/Login';
import SignupIcon from '@mui/icons-material/PersonAdd';
import HomeIcon from '@mui/icons-material/Home';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { observer } from 'mobx-react-lite';
import React, { useContext, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { userContext } from "../../stores/users/userContext";
import { messageContext } from "../../stores/messages/messageContext";
import EmoName from '../emo/emoName';
import { menuItemsNotLogged, menuItemsLogged } from "./constants";
import { EMO_NAME } from '../constants';

const drawerWidth = 240;

const DrawerAppBar = ({changeMode, mode}: any) => {
    const navigate = useNavigate()
    const [mobileOpen, setMobileOpen] = useState(false);
    const user = useContext(userContext)
    const messageStore = useContext(messageContext)

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    const getMenuIcon = (itemName: string) => {
        switch (itemName) {
            case 'Home': return <HomeIcon />;
            case 'Videos': return <VideoLibraryIcon />;
            case 'Upload': return <UploadIcon />;
            case 'Download': return <DownloadIcon />;
            case 'Transcript': return <TranscribeIcon />;
            case 'My creations': return <CreateIcon />;
            case 'Usage': return <BarChartIcon />;
            case 'Profile': return <PersonIcon />;
            case 'Log out': return <LogoutIcon />;
            case 'Pricing': return <PricingIcon />;
            case 'Contact': return <ContactIcon />;
            case 'About': return <InfoIcon />;
            case 'Log in': return <LoginIcon />;
            case 'Sign up': return <SignupIcon />;
            default: return null;
        }
    };

    const menuItems = (user.isUserAuth() ? menuItemsLogged : menuItemsNotLogged);

    const handleMenuItemClick = (index: number) => {
        const LINK = 1;
        const item = menuItems[index];
        
        setMobileOpen(false); // Close drawer
        if (item[LINK]) {
            navigate(item[LINK]);
        }
    };

    const enableButton = (item: string) => {

        switch (item) {
            case "Videos":
                return user.isUserStripeActive();
            case "Upload":
                return user.isUserStripeActive();
            case "Download":
                return user.isUserStripeActive();
            case "Profile":
                return true;
            case "Transcript":
                return user.getUserTranscriptId()
            case "My creations":
                return user.isUserStripeActive();
            case "Usage":
                return user.isUserStripeActive();
            case "Log out":
                return true;
            case "Log in":
                return !user.isUserAuth();
            case "Sign up":
                return !user.isUserAuth();
            case "Pricing":
                return true;
            case "Contact":
                return true;
            case "About":
                return true;
            default:
                return false;
        }
    };

    
    const drawer = (
        <Box sx={{textAlign: 'center'}}>
            <Typography variant="h6" sx={{my: 2}}>
                <Link to='/' style={{ textDecoration: 'none', color: 'inherit' }}>
                    {EMO_NAME}
                </Link>
                <IconButton color="inherit" onClick={changeMode}>
                    {mode === 'light' ? <Brightness7Icon/> : <Brightness4Icon/>}
                </IconButton>
            </Typography>
            <Divider/>
            <List>
                {menuItems.map((item, index) => {
                    const ITEM = 0;
                    
                    if (item[ITEM] === '-') {
                        return <Divider key={index} />;
                    }
                    
                    return (
                        <ListItem key={index} disablePadding>
                            <ListItemButton 
                                onClick={() => handleMenuItemClick(index)}
                                disabled={ ! enableButton(item[ITEM])}
                            >
                                <ListItemIcon>
                                    {getMenuIcon(item[ITEM])}
                                </ListItemIcon>
                                <ListItemText primary={item[ITEM]} />
                            </ListItemButton>
                        </ListItem>
                    );
                })}
            </List>
        </Box>
    );

    return (
        <Box sx={{display: 'flex'}}>
            <AppBar component="nav">
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                       
                    >
                        <MenuIcon/>
                    </IconButton>
                    <EmoName name={EMO_NAME}/>
                </Toolbar>
            </AppBar>
            <nav>
                <Drawer
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: 'block',
                        zIndex: 1400, // Higher than draggable toolbar (1300) and views menu (1200)
                        '& .MuiDrawer-paper': {
                            boxSizing: 'border-box', 
                            width: drawerWidth,
                            zIndex: 1400 // Ensure the paper also has high z-index
                        },
                    }}
                >
                    {drawer}
                </Drawer>
            </nav>
        </Box>
    );
}

export default observer(DrawerAppBar)